import { OrderDto } from './order.dto';

export class GiftCardTransactionOrderDetailsDto {
  transactionId: number;
  order: Pick<OrderDto, 'id' | 'createdDate'>;
  orderItems: {
    id: number;
    quantity: number;
    productId: number;
    modifiers?: {
      id: number;
      name: string;
    }[];
    product: {
      id: number;
      name: string;
    };
  }[];
}
